import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const LazyAIPlannerSyncByline: LoadableType<{
	contentId: string;
	contentType?: string | null;
	generatedBy?: string | null;
	isEmbeddedConfluence: boolean;
	spaceName?: string | null;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AIPlannerSyncByline" */ './AIPlannerSyncByline.tsx'
			)
		).AIPlannerSyncByline,
	loading: () => null,
});
